import { React, useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReorderIcon from '@mui/icons-material/Reorder';

import '../styles/HamburgerDropdown.css';

const HamburgerDropdown = ({ options }) => {
    const [burgerOpen, setIsOpen] = useState(false);
    const burgerRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!burgerOpen);
    };

    const handleClickOutside = (event) => {
        if (burgerRef.current && !burgerRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    const handleCloseOnResize = () => {
        setIsOpen(false); // Close the dropdown when the window is resized
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        window.addEventListener('resize', handleCloseOnResize); // Add event listener for window resize
        return () => {
            document.removeEventListener('click', handleClickOutside);
            window.removeEventListener('resize', handleCloseOnResize); // Remove event listener on component unmount
        };
    }, []);

    return (
        <div className='hamburger-dropdown' ref={burgerRef}>
            <Link onClick={toggleDropdown} className='navbutton'><ReorderIcon/></Link>    
            {burgerOpen && (
                 <div className="hamburger-dropdown-content">                
                    {options.map((option, index) => (
                        <li key={index}>
                            <Link to={option.link}>{option.label}</Link>
                        </li>
                    ))}                    
                 </div>
            )}
        </div>
    );
};

export default HamburgerDropdown;